export default function TexarkanaAcceptanceFacilitiesSection() {
  const facilities = [
    {
      name: "Texarkana Main Post Office",
      address: "901 N State Line Ave, Texarkana, AR 71854",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(870) 774-2573",
      notes: "Primary acceptance facility for Texarkana AR residents. Sits directly on the state line. Appointment required — call ahead or book via USPS.com.",
    },
    {
      name: "Texarkana TX Post Office",
      address: "600 Olive St, Texarkana, TX 75501",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(903) 792-6456",
      notes: "TX-side option for Texarkana residents — passport applications accepted regardless of which state you live in. Call to confirm passport acceptance clerk availability.",
    },
    {
      name: "Miller County Circuit Clerk",
      address: "400 Laurel St, Texarkana, AR 71854",
      hours: "Mon–Fri 8:00 AM – 4:30 PM",
      phone: "(870) 774-1501",
      notes: "Serves Miller County residents for certified document requests and notarization. Useful when gathering supporting documents for passport applications.",
    },
    {
      name: "Hope Post Office",
      address: "100 W 4th St, Hope, AR 71801",
      hours: "Mon–Fri 9:00 AM – 3:30 PM",
      phone: "(870) 777-1520",
      notes: "Hempstead County option for Hope and surrounding area residents. Call ahead to confirm passport acceptance clerk availability.",
    },
  ];

  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where to Submit a New Passport in Texarkana
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants and minors must visit an acceptance clerk in person. Texarkana residents can use either AR-side or TX-side acceptance facilities — though most travelers using Fast Passport Center ship documents directly to us after their clerk visit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {facilities.map((f, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#1A365D] text-base"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                  <p className="text-gray-500 text-xs mt-0.5">{f.address}</p>
                </div>
              </div>
              <div className="space-y-1.5 text-xs text-gray-500 ml-12">
                <p><i className="ri-time-line text-[#F6C344] mr-1"></i>{f.hours}</p>
                <p><i className="ri-phone-line text-[#F6C344] mr-1"></i>{f.phone}</p>
              </div>
              <div className="mt-3 ml-12 bg-white rounded-md p-3 border border-gray-200">
                <p className="text-gray-500 text-xs leading-relaxed">{f.notes}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col md:flex-row items-center gap-5 text-center md:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-lightbulb-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base mb-1">How This Works With Fast Passport Center</p>
            <p className="text-white/60 text-sm leading-relaxed">
              Visit the clerk with your sealed envelope — AR-side or TX-side, your choice — then ship it overnight to Fast Passport Center for expedited processing. No need to drive to Hot Springs for a passport agency appointment.
            </p>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Start Now <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}